const getters = {
  getObservation(state) {
    if (
      !state.observation ||
      (typeof state.observation).toLowerCase() != 'object'
    )
      return '';
    return (protocol) => state.observation.get(protocol) || '';
  },
};

export default getters;
